import { render } from "./MobileSocials.vue?vue&type=template&id=659e1dd2&scoped=true"
import script from "./MobileSocials.vue?vue&type=script&lang=js"
export * from "./MobileSocials.vue?vue&type=script&lang=js"

import "./MobileSocials.vue?vue&type=style&index=0&id=659e1dd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659e1dd2"]])

export default __exports__